import { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

type AdvisorEditorSectionProps = {
  title: string;
  defaultOpen?: boolean;
  children: React.ReactNode;
};

export const AdvisorEditorSection = ({
  title,
  defaultOpen = true,
  children,
}: AdvisorEditorSectionProps) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <section className="rounded-lg border border-gray-200 bg-white">
      <button
        type="button"
        className="flex w-full items-center justify-between px-6 py-4 text-left hover:bg-gray-50"
        onClick={() => setIsOpen((current) => !current)}
      >
        <h3 className="text-lg font-medium text-gray-900">{title}</h3>
        {isOpen ? (
          <ChevronUp className="h-5 w-5 text-gray-400" />
        ) : (
          <ChevronDown className="h-5 w-5 text-gray-400" />
        )}
      </button>
      {isOpen && <div className="border-t border-gray-200 px-6 py-6">{children}</div>}
    </section>
  );
};
